import React, { Component } from 'react';
import { firebaseRef } from '../firebase.js';
import { withRouter } from 'react-router';
import Inputcomponent from './inputComponnent.js';

class OcLtInEx extends Component {
  constructor(props){
    super(props);
    this.state = {
      checkingOcLt: '',
      checkingInEx: '',
      loader: true,
    }
    this.componentWillMount = this.componentWillMount.bind(this);
    this.checkingInEx = this.checkingInEx.bind(this);
    this.checkingOcLt = this.checkingOcLt.bind(this);
  }



    componentWillMount(){
    var that=this;
    //this.setState({ loader: true });
    var userId = this.props.match.params.user;
    var doctor = this.props.match.params.doctor;
    var refMainOcLt = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/oc-lt');
    var refMainInEx = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/in-ex');
    refMainOcLt.on('child_added', (datasnapShot) => {
      var value = datasnapShot.val();
        that.setState({ checkingOcLt: value });
});
refMainInEx.on('child_added', (datasnapShot) => {
  var value = datasnapShot.val();
    that.setState({ checkingInEx: value, loader: false });
});
}

checkingOcLt(event){
  //event.preventDefault();
  this.setState({ checkingOcLt: event.target.value });
  var user = this.props.match.params.user;
  var doctor = firebaseRef.auth().currentUser.uid;
  var refMainOcLt = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/oc-lt');
  refMainOcLt.update({
    "ocLt": event.target.value,
  });
}
checkingInEx(event){
  //event.preventDefault();
  this.setState({ checkingInEx: event.target.value });
  var user = this.props.match.params.user;
  var doctor = firebaseRef.auth().currentUser.uid;
  var refMainOcLt = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/in-ex');
  refMainOcLt.update({
    "inEx": event.target.value,
  });
}


  render() {
    //const image = <img src={this.state.imgUrl} width="250px" height="150px" />
    return (
        <div id="oc-lt-in-ex-user-image">
          <form className="user-forms" align="center" id="oc-lt-in-ex-form">
          <div className="forms-container-flex">
          <div className="inputs-container">
            <Inputcomponent title="Oc" group="oc-lt" checking={this.state.checkingOcLt} click={this.checkingOcLt}/>
            <Inputcomponent title="Lt" group="oc-lt" checking={this.state.checkingOcLt} click={this.checkingOcLt}/>
            <Inputcomponent title="Rt" group="oc-lt" checking={this.state.checkingOcLt} click={this.checkingOcLt}/>
          </div>
          <div className="inputs-container">
            <Inputcomponent title="Ex" group="in-ex" checking={this.state.checkingInEx} click={this.checkingInEx}/>
            <Inputcomponent title="In" group="in-ex" checking={this.state.checkingInEx} click={this.checkingInEx}/>
            <Inputcomponent group="none" checking="none"/>
          </div>
            </div>
            <div className="inputs-container">
            </div>
          </form>


        </div>
    );
  }
}

export default withRouter(OcLtInEx);



// WEBPACK FOOTER //
// ./src/routes/Paitent/OcLt-InEx.js